/** Maximum sorted-column key length accepted from clients — real grid column keys are far shorter. */
export const ASSISTANT_GRID_SORT_COLUMN_KEY_MAX_CHARACTERS = 128;
